import { cn } from '@/lib/utils'

import { CaseStatusBreakdown } from './ui/case-status-breakdown/case-status-breakdown'
import { CaseTypeBreakdown } from './ui/case-type-breakdown/case-type-breakdown'
import useCaseAnalysisPage from './use-page'

export const DashboardCaseAnalysisPage = () => {
  const { assignees, tags } = useCaseAnalysisPage()

  return (
    <div className={cn('mt-5', 'flex flex-col gap-5')}>
      <CaseTypeBreakdown assignees={assignees} tags={tags} />
      <CaseStatusBreakdown assignees={assignees} tags={tags} />
    </div>
  )
}
